export class FleetProfitModel {
  [key: string]: any;

  totalProfit!: number;
  fixedProfit!: number;
  variableProfit!: number;
}
